cbp-section:not([hidden]) {
  display: block;
}
